import * as R from 'remeda'
import type { Filter } from '../../../../types/api/reports'
import type { FilterParams } from './queries'

export const generateFilterParams = (filters: Filter[]) =>
  R.pipe(
    filters,
    R.filter(
      ({ value, is_active }) =>
        is_active &&
        R.isNonNullish(value) &&
        (R.isNot(R.isArray)(value) || R.isNot(R.isEmpty)(value)),
    ),
    R.map(filter => ({ filter: filter.filter, value: filter.value })),
  ) as FilterParams
